import React from "react";
import { brandAssets } from "../../data/commerce";
import { LinkButton } from "../ui/Buttons";
import { OfferCountdown } from "./OfferCountdown";
const navLinks = [{
  href: "#tomos",
  label: "Tomos"
}, {
  href: "#bonos",
  label: "Bonos"
}, {
  href: "#planes",
  label: "Planes"
}, {
  href: "#preguntas",
  label: "Preguntas"
}];
export function Header() {
  return <header className="sticky top-0 z-40" data-id="element-114" data-mp="3fmfx251voefb">
      <OfferCountdown data-id="element-115" data-mp="2ivduvux0szd4" />
      <div className="border-b border-pizarra/10 bg-marfil/90 backdrop-blur" data-id="element-116" data-mp="2ivx6ktw2urip">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4 md:h-[72px] md:px-6" data-id="element-117" data-mp="2nugtawihw7c4">
          <a href="#inicio" className="flex shrink-0 items-center" aria-label="Recursos Practic & Simple, ir al inicio" data-id="element-118" data-mp="2rth7u2txwntb">
            <img src={brandAssets.logo} alt="Recursos Practic & Simple" className="h-11 w-auto mix-blend-multiply md:h-12" data-id="element-119" data-mp="2ws0wiazx4dpd" />
          </a>
          <nav aria-label="Principal" className="hidden md:block" data-id="element-120" data-mp="c3d1aquaqmq0">
            <ul className="flex items-center gap-7 text-[15px] font-medium text-pizarra" data-id="element-121" data-mp="c5pk167vp144">
              {navLinks.map(l => <li key={l.href} data-id="element-122" data-mp="14r03bwy85yyl">
                  <a href={l.href} className="transition-colors duration-150 hover:text-terracota-deep" data-id="element-123" data-mp="14s2rhx45xnat">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </nav>
          <LinkButton href="#planes" className="!px-5 !py-2.5 !text-sm" data-id="element-124" data-mp="uvg9rh74vcd0">
            Ver los planes
          </LinkButton>
        </div>
      </div>
    </header>;
}